import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import styles from "../../../../InfoCliniche/InfoCliniche.module.css";
import Utils from "../../../../../../../utils/Utils";

class InformazioniGenerali extends Component {
    state = {
        InformazioniGenerali: {
            donatore: "",
            haDonato28Giorni: "",
            tipoDonatore: [],
            anamnesiTrasfusione: "",
            anamnesiTrapianto: "",
            gravidanza: "",
            gravidanzaSettimane: "",
            corretto: []
        }
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreCheckbox = this.riceviValoreCheckbox.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.informazioniGenerali) {
            this.setState({
                InformazioniGenerali: {
                    ...this.state.InformazioniGenerali,
                    ...JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.informazioniGenerali)),
                    corretto: []
                }
            }, () => this.aggiornaPadre());

        } else if (this.props.segnalazioneCopia.datiSanitari?.asintomatico != null) {
            this.setState(prev => ({
                InformazioniGenerali: {
                    ...prev.InformazioniGenerali,
                    donatore: this.props.segnalazioneCopia.datiSanitari.asintomatico === "true" ? "01" : "",
                }
            }), () => this.aggiornaPadre());
        } else {
            this.aggiornaPadre();
        }
    }

    // Firma (field, event) identica a classificazioneDelCaso
    riceviValore(arg1, arg2) {
        let dati = this.state.InformazioniGenerali;
        let field, valore;

        if (typeof arg1 === "string" && arg2 && arg2.target) {
            // Chiamata da Input component: riceviValore("note", event)
            field = arg1;
            valore = arg2.target.value;
        } else if (typeof arg1 === "string" && (typeof arg2 === "string" || arg2 === undefined)) {
            // Chiamata diretta con valore: riceviValore("donatore", "01")
            field = arg1;
            valore = arg2;
        } else if (arg1 && arg1.target) {
            // Chiamata con solo evento: riceviValore(event)
            field = arg1.target.id || arg1.target.name;
            valore = arg1.target.value;
        }

        if (field) {
            dati[field] = valore;

            // Business rules: reset campi dipendenti
            if (field === "donatore" && valore !== "01") {
                dati.haDonato28Giorni = "";
                dati.tipoDonatore = [];
            }
            if (field === "gravidanza" && valore !== "01") {
                dati.gravidanzaSettimane = "";
            }

            this.setState({ InformazioniGenerali: dati }, () => {
                this.aggiornaPadre();
            });
        }
    }

    riceviValoreCheckbox(labelValue) {
        this.setState(prevState => {
            let nuovaInfo = JSON.parse(JSON.stringify(prevState.InformazioniGenerali));
            let list = [...(nuovaInfo.tipoDonatore || [])];

            if (list.includes(labelValue)) {
                list = list.filter(i => i !== labelValue);
            } else {
                list.push(labelValue);
            }

            nuovaInfo.tipoDonatore = list;
            return { InformazioniGenerali: nuovaInfo };
        }, () => this.aggiornaPadre());
    }

    // Aggiunto per specularità con classificazioneDelCaso
    controlloCorrettezza() {
        let dati = this.state.InformazioniGenerali;
        dati.corretto = [];
    }

    // Estratto in metodo dedicato come in classificazioneDelCaso
    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.InformazioniGenerali));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    // Struttura identica a classificazioneDelCaso
    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();

        let oggettoBE = this.createOggettoBE();
        if (this.props.setInformazioniGenerali) {
            this.props.setInformazioniGenerali(this.state.InformazioniGenerali, oggettoBE);
        }
    }

    render() {
        const { t } = this.props;
        const { InformazioniGenerali: data } = this.state;
        const path = "SchedaSpecialeArbovirosi.InformazioniGenerali";

        const labelSi = t("SchedaSpecialeTubercolosi.si");
        const labelNo = t("SchedaSpecialeTubercolosi.no");
        const labelNonNoto = t("SchedaSpecialeTubercolosi.nonNoto");

        const labelSangue = t(`${path}.tipoOpzioni.sangue`);
        const labelTessuti = t(`${path}.tipoOpzioni.tessuti`);
        const labelCellule = t(`${path}.tipoOpzioni.cellule`);
        const labelOrgani = t(`${path}.tipoOpzioni.organi`);

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.donatore`)}</p>
                    </div>
                    <div className="col-lg-7">
                         <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                             <RadioButton id="donSi" label={labelSi} value="01"
                                 checked={data.donatore === "01"}
                                 onClick={() => this.riceviValore("donatore", "01")}
                                 newRadio={true} />
                             <RadioButton id="donNo" label={labelNo} value="02"
                                 checked={data.donatore === "02"}
                                 onClick={() => this.riceviValore("donatore", "02")}
                                 newRadio={true} />
                         </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                        {t(`${path}.donato28Giorni`)}</p>
                    </div>

                    <div className="col-lg-7">
                        <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                            <RadioButton id="haDonSi" label={labelSi} value="01"
                                checked={data.haDonato28Giorni === "01"}
                                onClick={() => this.riceviValore("haDonato28Giorni", "01")}
                                disabled={data.donatore !== "01"} newRadio={true} />
                            <RadioButton id="haDonNo" label={labelNo} value="02"
                                checked={data.haDonato28Giorni === "02"}
                                onClick={() => this.riceviValore("haDonato28Giorni", "02")}
                                disabled={data.donatore !== "01"} newRadio={true} />
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.tipoDonatore`)}</p>
                    </div>
                    <div className="col-lg-7">
                        <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                            <div className={"col-lg-2"} style={{marginLeft: "-4px"}}>
                                <CheckBox id="tipoSangue" text={labelSangue}
                                          checked={data.tipoDonatore.includes(labelSangue)}
                                          onChange={() => this.riceviValoreCheckbox(labelSangue)}
                                          disabledFlag={data.donatore !== "01" || data.donatore === ""} newCheckbox={true} />
                                <CheckBox id="tipoTessuti" text={labelTessuti}
                                          checked={data.tipoDonatore.includes(labelTessuti)}
                                          onChange={() => this.riceviValoreCheckbox(labelTessuti)}
                                          disabledFlag={data.donatore !== "01" || data.donatore === ""} newCheckbox={true} />
                            </div>
                            <div className={"col-lg-2"}>
                                <CheckBox id="tipoCellule" text={labelCellule}
                                          checked={data.tipoDonatore.includes(labelCellule)}
                                          onChange={() => this.riceviValoreCheckbox(labelCellule)}
                                          disabledFlag={data.donatore !== "01" || data.donatore === ""} newCheckbox={true} />
                                <CheckBox id="tipoOrgani" text={labelOrgani}
                                          checked={data.tipoDonatore.includes(labelOrgani)}
                                          onChange={() => this.riceviValoreCheckbox(labelOrgani)}
                                          disabledFlag={data.donatore !== "01" || data.donatore === ""} newCheckbox={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.anamnesiTrasfusione`)}</p>
                    </div>
                    <div className="col-lg-7">
                        <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                            <RadioButton id="trasfSi" label={labelSi} value="01"
                                checked={data.anamnesiTrasfusione === "01"}
                                onClick={() => this.riceviValore("anamnesiTrasfusione", "01")}
                                newRadio={true} />
                            <RadioButton id="trasfNo" label={labelNo} value="02"
                                checked={data.anamnesiTrasfusione === "02"}
                                onClick={() => this.riceviValore("anamnesiTrasfusione", "02")}
                                newRadio={true} />
                            <RadioButton id="trasfNN" label={labelNonNoto} value="03"
                                checked={data.anamnesiTrasfusione === "03"}
                                onClick={() => this.riceviValore("anamnesiTrasfusione", "03")}
                                newRadio={true} />
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.anamnesiTrapianto`)}</p>
                    </div>
                    <div className="col-lg-7">
                        <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                            <RadioButton id="trapSi" label={labelSi} value="01"
                                checked={data.anamnesiTrapianto === "01"}
                                onClick={() => this.riceviValore("anamnesiTrapianto", "01")}
                                newRadio={true} />
                            <RadioButton id="trapNo" label={labelNo} value="02"
                                checked={data.anamnesiTrapianto === "02"}
                                onClick={() => this.riceviValore("anamnesiTrapianto", "02")}
                                newRadio={true} />
                            <RadioButton id="trapNN" label={labelNonNoto} value="03"
                                checked={data.anamnesiTrapianto === "03"}
                                onClick={() => this.riceviValore("anamnesiTrapianto", "03")}
                                newRadio={true} />
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={"col-lg-4"}>
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.gravidanza`)}</p>
                    </div>
                    <div className="col-lg-7">
                        <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                            <RadioButton id="gravSi" label={labelSi} value="01"
                                checked={data.gravidanza === "01"}
                                onClick={() => this.riceviValore("gravidanza", "01")}
                                newRadio={true} />
                            <RadioButton id="gravNo" label={labelNo} value="02"
                                checked={data.gravidanza === "02"}
                                onClick={() => this.riceviValore("gravidanza", "02")}
                                newRadio={true} />

                            <div className={"col-lg-2 align-self-center"}  style={{marginLeft: "50px"}}>
                                <span style={{ fontSize: "14px" }}>{t(`${path}.settimaneGravidanza`)}</span>
                            </div>
                            <div className={"col-lg-2"}>
                                <Input
                                    id="gravSett"
                                    field={"Settimane"}
                                    value={data.gravidanzaSettimane}
                                    onChange={(field, e) => this.riceviValore("gravidanzaSettimane", e)}
                                    placeholder={t(`${path}.settimanePlaceholder`)}
                                    disabled={data.gravidanza !== "01"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(InformazioniGenerali);